import { type OpenApiSchemaDeliveryWarehouse } from '#shared/api/schema';

export const isWarehouseEnabled = (warehouse: OpenApiSchemaDeliveryWarehouse): boolean =>
    warehouse.settings.yandex.enabled ||
    warehouse.settings.cdek.enabled ||
    warehouse.settings.meta_ship_dalli.enabled ||
    warehouse.settings.meta_ship_russian_post.enabled ||
    warehouse.settings.meta_ship_pecom.enabled ||
    warehouse.settings.ozon.enabled ||
    warehouse.settings.merchant_ship.enabled ||
    warehouse.settings.self_pick_up.enabled ||
    warehouse.settings.yandex_market_fbo.enabled ||
    warehouse.settings.ycp_delivery.enabled;
